<template>
  <div id="impersonate" style="height: 100%">
  </div>
</template>

<script>
export default {
  name: 'impersonate',
  data () { // 所有的数据都写在里面
    return {
      msg: '',
      account: '',
      myPassword: '',
      token: this.$route.query.token,
      loginSelt: 1,
      loginInfo: {
        email: '',
        userName: '',
        name: '',
        password: '',
        newPassword: ''
      },
      goInfo: {
        email: '',
        // name: '',
        password: ''
      },
      remBer: '',
      canPost: false,
      canPost2: false,
      verifyCode: '',
      verifyCode2: '',
      imgArr: [
        // {
        //   src: require('../../../assets/logBj_01.jpg')
        // },
        // {
        //   src: require('../../../assets/logBj_02.jpg')
        // },
        // {
        //   src: require('../../../assets/logBj_03.jpg')
        // }
      ],
      selected: 0, // 当前展示的图片
      imgWidth: 0, // 图片宽度
      flag: true, // 节流阀，防止连续点击切换,
      autoSwitch: null,
      urlUserName: ''
    }
  },
  created () {
    if (this.$route.query.userName) {
      this.toUrlLog()
    }
  },
  mounted () {
  },
  methods: {// 所有的方法写在里面
    toUrlLog () {
      this.$axiox.get('/api/User/impersonate?userName=' + this.$route.query.userName).then(msg => {
        localStorage.coeToken = msg.data.token
        localStorage.logInfo = JSON.stringify(msg.data)
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '登录成功',
          stayTime: 5
        })
        this.$router.push({
          name: 'index'
        })
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
  .loginButn {
    background-color: #12ABDB;
    border-radius: 5px;
    border: 1px solid transparent;
    padding: 10px 20px;
    color:#fff;
    outline: none;
    font-size: 12px;
  }
  .allRadio + label {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1px solid #0070AD;
    border-radius: 50%;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
    margin:0 10px 0 0;
  }
  .allRadio:checked + label{
    border: 1px solid #0070AD;
    background-color: white;
  }
  .allRadio:checked + label:after{
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border-radius:10px ;
    position: absolute;
    top: 3px;
    left: 3px;
    background-color: #0070AD;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/login/impersonate.vue